export default __webpack_public_path__ + "static/media/image.96a681c1.png";